import Accordion from "../../components/Accordion";
import Modal from "../../components/Modal";
import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";
import { motion } from "framer-motion";

const url = `
  https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/554e6605-a254-4d96-97b8-16b0adab1b40
  ?include=field_imagen1.field_media_image,field_imagen2.field_media_image,field_imagen3.field_media_image,
  field_imagen5.field_media_image,field_imagen6.field_media_image,
  field_imagen8.field_media_image,field_imagen9.field_media_image,
  field_imagen10.field_media_image,field_imagen11.field_media_image,
  field_imagen12.field_media_image,field_imagen13.field_media_image,
  field_imagen14.field_media_image,field_imagen15.field_media_image,
  field_imagen16.field_media_image,field_imagen17.field_media_image
  &fields[node--template_home]=title,field_texto_portada,
  field_imagen1,field_imagen2,field_imagen3,field_imagen5,field_imagen6,
  field_imagen8,field_imagen9,field_imagen10,field_imagen11,
  field_imagen12,field_imagen13,field_imagen14,field_imagen15,
  field_imagen16,field_imagen17,
  field_bloque1,field_bloque2,field_bloque3,field_bloque4,
  field_bloque5,field_bloque6,field_bloque7,field_bloque8,
  field_bloque9,field_bloque10,field_bloque11,field_bloque12,
  field_bloque13,field_bloque14,field_bloque15,field_bloque16,
  field_bloque17,field_bloque18
  &fields[media--image]=field_media_image
  &fields[file--file]=uri
`.replace(/\s+/g, "");

function GovTechSpeakers() {
  const DataDisplay = ({ data }) => (
    <div>
      <div className="flex flex-wrap justify-center gap-6 w-full max-w-6xl mx-auto pb-24">
        {data.bloque8 && (
          <motion.div
            className="w-full md:w-[calc(50%-12px)] p-6 bg-white rounded-xl border border-slate-200/80 shadow-sm"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, delay: 0.5 }}
          >
            <img
              src={data.imagen8}
              alt="utpl"
              className="w-full h-[200px] object-cover rounded-2xl shadow-lg"
            />

            <div
              className="[&_h2]:font-bold "
              dangerouslySetInnerHTML={{
                __html: data.bloque8,
              }}
            />
          </motion.div>
        )}

        {data.bloque9 && (
          <motion.div
            className="w-full md:w-[calc(50%-12px)] p-6 bg-white rounded-xl border border-slate-200/80 shadow-sm"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, delay: 1 }}
          >
            <img
              src={data.imagen9}
              alt="utpl"
              className="w-full h-[200px] object-cover rounded-2xl shadow-lg"
            />
            <div
              className="[&_h2]:font-bold "
              dangerouslySetInnerHTML={{
                __html: data.bloque9,
              }}
            />
          </motion.div>
        )}
      </div>

      <section className="py-20 px-6">
        <div
          className="max-w-6xl mx-auto text-center mb-6   [&_h2]:font-bold "
          dangerouslySetInnerHTML={{
            __html: data.texto_portada,
          }}
        />
        {/*speaker internacional */}
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-6">
          <div className="bg-slate-100 rounded-2xl pb-4">
            <img
              src={data.imagen1}
              alt="Speaker 3"
              className="w-full aspect-[5/5] object-cover rounded-2xl shadow-lg"
            />

            <div className="mt-4 text-center">
              <Modal
                title="Ver perfil"
                content={
                  <>
                    <div
                      className="link-with-arrow-1"
                      dangerouslySetInnerHTML={{
                        __html: data.bloque1,
                      }}
                    />
                  </>
                }
              ></Modal>
            </div>
          </div>
          <div className="bg-slate-100 rounded-2xl pb-4">
            <img
              src={data.imagen2}
              alt="Speaker 3"
              className="w-full aspect-[5/5] object-cover rounded-2xl shadow-lg"
            />

            <div className="mt-4 text-center">
              <Modal
                title="Ver perfil"
                content={
                  <>
                    <div
                      className="link-with-arrow-1"
                      dangerouslySetInnerHTML={{
                        __html: data.bloque2,
                      }}
                    />
                  </>
                }
              ></Modal>
            </div>
          </div>

       <div className="bg-slate-100 rounded-2xl pb-4">
            <img
              src={data.imagen3}
              alt="Speaker 3"
              className="w-full aspect-[5/5] object-cover rounded-2xl shadow-lg"
            />

            <div className="mt-4 text-center">
              <Modal
                title="Ver perfil"
                content={
                  <>
                    <div
                      className="link-with-arrow-1"
                      dangerouslySetInnerHTML={{
                        __html: data.bloque3,
                      }}
                    />
                  </>
                }
              ></Modal>
            </div>
          </div>

       <div className="bg-slate-100 rounded-2xl pb-4">
            <img
              src={data.imagen10}
              alt="Speaker 3"
              className="w-full aspect-[5/5] object-cover rounded-2xl shadow-lg"
            />

            <div className="mt-4 text-center">
              <Modal
                title="Ver perfil"
                content={
                  <>
                    <div
                      className="link-with-arrow-1"
                      dangerouslySetInnerHTML={{
                        __html: data.bloque10,
                      }}
                    />
                  </>
                }
              ></Modal>
            </div>
          </div>
        </div>
      </section>

      <section className="pb-20 px-6">
        <div
          className="max-w-6xl mx-auto text-center mb-6   [&_h2]:font-bold"
          dangerouslySetInnerHTML={{
            __html: data.bloque4,
          }}
        />

        {/*speaker nacional */}
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-6">
            <div className="bg-slate-100 rounded-2xl pb-4">
            <img
              src={data.imagen5}
              alt="Speaker 3"
              className="w-full aspect-[5/5] object-cover rounded-2xl shadow-lg"
            />

            <div className="mt-4 text-center">
              <Modal
                title="Ver perfil"
                content={
                  <>
                    <div
                      className="link-with-arrow-1"
                      dangerouslySetInnerHTML={{
                        __html: data.bloque5,
                      }}
                    />
                  </>
                }
              ></Modal>
            </div>
          </div>
         <div className="bg-slate-100 rounded-2xl pb-4">
            <img
              src={data.imagen6}
              alt="Speaker 3"
              className="w-full aspect-[5/5] object-cover rounded-2xl shadow-lg"
            />

            <div className="mt-4 text-center">
              <Modal
                title="Ver perfil"
                content={
                  <>
                    <div
                      className="link-with-arrow-1"
                      dangerouslySetInnerHTML={{
                        __html: data.bloque6,
                      }}
                    />
                  </>
                }
              ></Modal>
            </div>
          </div>

         <div className="bg-slate-100 rounded-2xl pb-4">
            <img
              src={data.imagen11}
              alt="Speaker 3"
              className="w-full aspect-[5/5] object-cover rounded-2xl shadow-lg"
            />

            <div className="mt-4 text-center">
              <Modal
                title="Ver perfil"
                content={
                  <>
                    <div
                      className="link-with-arrow-1"
                      dangerouslySetInnerHTML={{
                        __html: data.bloque11,
                      }}
                    />
                  </>
                }
              ></Modal>
            </div>
          </div>

          <div className="bg-slate-100 rounded-2xl pb-4">
            <img
              src={data.imagen12}
              alt="Speaker 3"
              className="w-full aspect-[5/5] object-cover rounded-2xl shadow-lg"
            />

            <div className="mt-4 text-center">
              <Modal
                title="Ver perfil"
                content={
                  <>
                    <div
                      className="link-with-arrow-1"
                      dangerouslySetInnerHTML={{
                        __html: data.bloque12,
                      }}
                    />
                  </>
                }
              ></Modal>
            </div>
          </div>

          <div className="bg-slate-100 rounded-2xl pb-4">
            <img
              src={data.imagen13}
              alt="Speaker 3"
              className="w-full aspect-[5/5] object-cover rounded-2xl shadow-lg"
            />

            <div className="mt-4 text-center">
              <Modal
                title="Ver perfil"
                content={
                  <>
                    <div
                      className="link-with-arrow-1"
                      dangerouslySetInnerHTML={{
                        __html: data.bloque13,
                      }}
                    />
                  </>
                }
              ></Modal>
            </div>
          </div>

          <div className="bg-slate-100 rounded-2xl pb-4">
            <img
              src={data.imagen14}
              alt="Speaker 3"
              className="w-full aspect-[5/5] object-cover rounded-2xl shadow-lg"
            />

            <div className="mt-4 text-center">
              <Modal
                title="Ver perfil"
                content={
                  <>
                    <div
                      className="link-with-arrow-1"
                      dangerouslySetInnerHTML={{
                        __html: data.bloque14,
                      }}
                    />
                  </>
                }
              ></Modal>
            </div>
          </div>

           <div className="bg-slate-100 rounded-2xl pb-4">
            <img
              src={data.imagen15}
              alt="Speaker 3"
              className="w-full aspect-[5/5] object-cover rounded-2xl shadow-lg"
            />

            <div className="mt-4 text-center">
              <Modal
                title="Ver perfil"
                content={
                  <>
                    <div
                      className="link-with-arrow-1"
                      dangerouslySetInnerHTML={{
                        __html: data.bloque15,
                      }}
                    />
                  </>
                }
              ></Modal>
            </div>
          </div>

          <div>
            <img
              src={data.imagen16}
              alt="Speaker 3"
              className="w-full aspect-[5/5] object-cover rounded-2xl shadow-lg"
            />

            <div className="mt-4 text-center">
              <Modal
                title="Ver perfil"
                content={
                  <>
                    <div
                      className="link-with-arrow-1"
                      dangerouslySetInnerHTML={{
                        __html: data.bloque16,
                      }}
                    />
                  </>
                }
              ></Modal>
            </div>
          </div>
        </div>
      </section>
    </div>
  );

  return (
    <DataFetcherTemplateHome url={url}>
      {(data) => <DataDisplay data={data} />}
    </DataFetcherTemplateHome>
  );
}

export default GovTechSpeakers;
